module.exports = __webpack_public_path__ + "img/xero-logo.b336bf23.png";